var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgShieldOffFill = function SvgShieldOffFill(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.85 16.05 6.8 3.95l4.5-1.675a2.1 2.1 0 0 1 .7-.125q.35 0 .7.125l6 2.25q.575.225.938.725.362.5.362 1.125V11.1a11.2 11.2 0 0 1-1.15 4.95m-2.3 3.3a8.7 8.7 0 0 1-1.812 1.475q-.988.6-2.113.975-.15.05-.3.075T12 21.9q-.1 0-.625-.1Q8 20.676 6 17.637 4 14.6 4 11.1V6.8L2.1 4.9a.95.95 0 0 1-.275-.7q0-.425.275-.7a.95.95 0 0 1 .7-.275q.425 0 .7.275l17 17a.95.95 0 0 1 .275.7.95.95 0 0 1-.275.7.95.95 0 0 1-.7.275.95.95 0 0 1-.7-.275z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgShieldOffFill);
export { ForwardRef as ReactComponent };